<div class="topicTabsContainer" *ngIf="selectedArticle !== null">
  <div class="menuNotifier" [innerHtml]="topicTitles[selectedArticle]" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()"></div>
  <div class="topicTabs" [ngClass]="{ 'open': navbarOpen }">
    <a *ngFor="let topic of objectKeys(topicTitles)" [routerLink]="'/enterprise/'+topic" class="topicTab" [ngClass]="{ 'selected': selectedArticle === topic }" (click)="closeNavbar()">{{topicTitles[topic]}}</a>
  </div>
  <div class="chevron" [ngClass]="{ 'open': navbarOpen }" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()"></div>
</div>
